// (function ($) {
//   jQuery.fn.isInViewport = function () {
//     var elementTop = jQuery(this).offset().top;
//     var elementBottom = elementTop + jQuery(this).outerHeight();

//     var viewportTop = jQuery(window).scrollTop();
//     var viewportBottom = viewportTop + jQuery(window).height();

//     return elementBottom > viewportTop && elementTop < viewportBottom;
//   };
// })(jQuery);

var menuFixed = false;

var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i) ? true : false;
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i) ? true : false;
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPod/i) ? true : false;
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i) ? true : false;
    },
    any: function () {
        return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Windows()
        );
    },
};

function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

window.ajaxified_form = function ({
    formData,
    $form,
    type,
    ajaxAction,
    elementErrorMessage,
    elementSubmitButton,
    successCallback,
}) {
    formData.append("action", ajaxAction);
    formData.append("nouncecheck", ajaxScript.nouncecheck);
    formData.append("formtype", type);

    jQuery.ajax({
        type: "POST",
        url: ajaxScript.ajaxurl,
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        dataType: "json",
        beforeSend: function () {
            elementErrorMessage.slideUp();
            elementSubmitButton.val("Enviando...").attr("disabled", "disabled");
        },
        error: function (data) {
            // console.error("ajaxified_form_error:::", data);

            elementSubmitButton
                .removeAttr("disabled")
                .val(elementSubmitButton.data("label"));

            if (typeof errorCallback === "function") {
                errorCallback(data);
            } else {
                elementErrorMessage
                    .slideDown()
                    .text(
                        "Ocorreu um erro. Por favor, confira seus dados e tente novamente."
                    );
            }
        },
        success: function (data) {
            // console.log("ajaxified_form_success:::", data);

            elementSubmitButton
                .removeAttr("disabled")
                .val(elementSubmitButton.data("label"));

            if (data.status === "success") {
                $form.trigger("reset");
                $form.find('input[type="file"]').each(function () {
                    jQuery(this).val("");
                    jQuery(this).closest(".form-file").find("button").trigger("click");
                });

                if (typeof successCallback === "function") {
                    successCallback(data);
                }
            } else {
                let custom_message = "Alguns dados estão incorretos ou já existem em nossa base. Corrija as informações destacadas para concluir seu cadastro.";

                if (data.message) {
                    custom_message = "Ocorreu um erro: " + data.message + ".";
                }
                elementErrorMessage
                    .slideDown()
                    .text(custom_message);
            }
        },
    });
};

jQuery(document).ready(function ($) {
    $(".lazy").Lazy({
        scrollDirection: "vertical",
        effect: "fadeIn",
        visibleOnly: true,
    });

    // $(".has-modal-login").on("click", function () {
    //   $("#modal-login").fadeIn();
    //   $("#modal-login").modal({
    //     closeExisting: true,
    //   });
    // });

    // $(".has-modal-sign-up").on("click", function () {
    //   $("#modal-sign-up").fadeIn();
    //   $("#modal-sign-up").modal({
    //     closeExisting: true,
    //   });
    // });

    // $(".has-modal").on("click", function () {
    //   $("body").css("overflow", "hidden");

    //   let id = $(this).data("id");

    //   if (id != "" && id > 0) {
    //     let formData = new FormData();
    //     formData.append("id", id);
    //     formData.append("action", "get_modal_content");

    //     $.ajax({
    //       type: "POST",
    //       url: ajaxScript.ajaxurl,
    //       dataType: "json",
    //       processData: false,
    //       contentType: false,
    //       data: formData,

    //       success: function (data) {
    //         $("#modal-default #tag").text(data.tag);
    //         $("#modal-default #title-container h3").text(data.title);
    //         $("#modal-default img").attr("src", data.thumbnail);
    //         $("#modal-default #text-content").html(decodeHtml(data.text));
    //         $("#modal").fadeIn();
    //       },
    //       error: function (data) {
    //         console.log(data);
    //       },
    //     });
    //   }
    // });

    $("#header-mobile-menu .hamburger").on("click", function () {
        jQuery(this).toggleClass("is-active");
    });

    // $("#modal-close, #modal-background").on("click", function () {
    $("#modal-close").on("click", function () {
        $("body").css("overflow", "auto");
        $("#modal").fadeOut();
        $("#modal-login").fadeOut();
    });

    const $forms = jQuery(".new-newsletter-form");

    // console.log($forms);

    jQuery(".form input, .form select, .form textarea").on(
        "change",
        function (e) {
            const $form = jQuery(this).closest(".form");

            dataLayer.push({
                event: $form.attr("data-tracking"),
                input: e.target.name,
            });
        }
    );

    //Validação de campos do formulário
    $.validator.addMethod(
        "validDateOfBirth",
        function (value, element) {
            const [day, month, year] = value.split("/").map(Number);
            const currentYear = new Date().getFullYear();
            const minYear = 1900;
            const minAge = 18;

            // Valida os limites de dia, mês e ano
            if (
                day < 1 ||
                day > 31 ||
                month < 1 ||
                month > 12 ||
                year < minYear ||
                year > currentYear
            ) {
                return false; // Data fora do intervalo
            }

            // Verifica se a data informada é válida
            const birthDate = new Date(year, month - 1, day);
            if (birthDate > new Date()) return false; // Data no futuro

            // Calcula a idade
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const isBirthdayPassed =
                today.getMonth() > birthDate.getMonth() ||
                (today.getMonth() === birthDate.getMonth() &&
                    today.getDate() >= birthDate.getDate());

            // Ajuste para a idade exata considerando o dia e mês
            if (!isBirthdayPassed) {
                age--;
            }

            return age >= minAge;
        },
        "Insira uma data válida. Apenas maiores de 18 anos."
    );

    //Fim data de nascimento
    $.validator.addMethod(
        "lettersonly",
        function (value) {
            const trimmedValue = value.trim();

            return /^[a-zA-ZÀ-ÖØ-öø-ÿ]+(\s+[a-zA-ZÀ-ÖØ-öø-ÿ]+)*$/.test(trimmedValue);
        },
        "*Este campo só aceita letras"
    );

    $.validator.addMethod(
        "validAge",
        function (value, element) {
            const minAge = 18;
            const birthDate = new Date(value);
            const today = new Date();

            //Verifica se o valor do campo é uma data válida
            if (isNaN(birthDate.getTime())) {
                return false;
            }

            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDifference = today.getMonth() - birthDate.getMonth();

            //Ajusta se a data de nascimento ainda não ocorreu no ano atual
            if (
                monthDifference < 0 ||
                (monthDifference === 0 && today.getDate() < birthDate.getDate())
            ) {
                age--;
            }

            //Verifica se a idade está no intervalo desejado
            return this.optional(element) || age >= minAge;
        },
        "Você precisa ter pelo menos 18 anos."
    );

    // $.validator.addMethod(
    //   "cpfBR",
    //   function (value) {
    //     value = value.replace(/[^\d]/g, "");

    //     if (value.length !== 11) {
    //       return false;
    //     }

    //     if (/^(\d)\1+$/.test(value)) {
    //       return false;
    //     }

    //     let sum = 0;
    //     let remainder;

    //     for (let i = 1; i <= 9; i++) {
    //       sum += parseInt(value.substring(i - 1, i)) * (11 - i);
    //     }
    //     remainder = (sum * 10) % 11;
    //     if (remainder === 10 || remainder === 11) {
    //       remainder = 0;
    //     }
    //     if (remainder !== parseInt(value.substring(9, 10))) {
    //       return false;
    //     }

    //     sum = 0;

    //     for (let i = 1; i <= 10; i++) {
    //       sum += parseInt(value.substring(i - 1, i)) * (12 - i);
    //     }
    //     remainder = (sum * 10) % 11;
    //     if (remainder === 10 || remainder === 11) {
    //       remainder = 0;
    //     }
    //     if (remainder !== parseInt(value.substring(10, 11))) {
    //       return false;
    //     }

    //     return true;
    //   },
    //   "Insira um CPF válido."
    // );

    $.validator.addMethod(
        "customEmail",
        function (value, element) {
            return (
                this.optional(element) || /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)
            );
        },
        "Por favor, insira um email válido."
    );

    const validation = $forms.validate({
        rules: {
            name: {
                lettersonly: true,
                minlength: 2,
                required: true,
            },
            phone: {
                minlength: 15,
                required: true,
            },
            // cpf: {
            //   cpfBR: false,
            //   required: true,
            // },
            age: {
                validDateOfBirth: true,
                required: true,
            },
            state: {
                required: true,
            },
            email: {
                customEmail: true,
                email: true,
                required: true,
            },
            aceite_politica_privacidade: {
                required: true,
            },
            aceite_seguranca_newsletter: {
                required: true,
            }
        },
        messages: {
            name: {
                minlength: "*Informe um nome com ao menos 2 letras.",
                required: "*Informe seu nome.",
            },
            phone: {
                minlength: "*Por favor, informe um telefone válido.",
                required: "*Informe seu telefone.",
            },
            cpf: {
                cpfBR: "*Por favor, informe um CPF válido.",
                required: "*Informe seu CPF.",
            },
            age: {
                min: "*É preciso ter 18 anos ou mais para se cadastrar.",
                required: "*Informe sua idade.",
            },
            state: {
                required: "*Informe seu estado.",
            },
            email: {
                email: "*Por favor, informe um email válido.",
                required: "*Informe seu email.",
            },
            aceite_politica_privacidade: {
                required: "*Este termo é obrigatório.",
            },
            aceite_seguranca_newsletter: {
                required: "*Este termo é obrigatório.",
            }
        },
        highlight: function (element, errorClass, validClass) {
            $(element)
                .parents(".form-group")
                .addClass(errorClass)
                .removeClass(validClass);
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).parents(".error").removeClass(errorClass).addClass(validClass);
        },
    });

    /**Envio */
    jQuery('#footer-newsletter input.new-newsletter-submit').on("click", (ev) => {
        jQuery(".form-error-message").val("");
        ev.preventDefault();
        //Começa aqui

        const form = document.querySelector(
            ".form.form--newsletter.new-newsletter-form"
        ); // Obtem o formulário atual
        const submitButton = form.querySelector(".new-newsletter-submit");
        const submitWrapper = submitButton.closest(
            ".new-newsletter-submit-wrapper"
        );
        // Verifica se estamos na página "Momentos Gourmet"
        if (
            document.body.classList.contains("seara-momento-gourmet") &&
            document.getElementById("form-action-name").value ===
            "cadastro_momentos_gourmet"
        ) {
            // Desabilita o botão e adiciona o loader
            submitButton.disabled = true;
            submitButton.dataset.originalText = submitButton.value;
            submitButton.value = "";

            // Adiciona o spinner se ele ainda não estiver presente
            if (!submitWrapper.querySelector(".button-loader-spinner")) {
                const loader = document.createElement("div");
                loader.className = "button-loader-spinner";
                submitWrapper.appendChild(loader);
            }
        }
        let checkboxSeara = document.querySelectorAll(".seara-form");
        if (checkboxSeara.length > 0) {
            const searaCheckbox = document.querySelector('input[name="seara"]');
            const searaGourmetCheckbox = document.querySelector(
                'input[name="seara-gourmet"]'
            );
            let campoSelected = document.querySelector(
                ".new-newsletter-opt .form-group"
            );
            //

            function removeStyles() {
                if (campoSelected) {
                    campoSelected.style.background = "";
                    campoSelected.style.borderColor = "";
                    let MsgError = document.querySelector("#error-brand");
                    if (MsgError) {
                        MsgError.remove();
                    }
                }
            }

            searaCheckbox.addEventListener("click", removeStyles);
            searaGourmetCheckbox.addEventListener("click", removeStyles);

            function isAnyCheckboxChecked() {
                return searaCheckbox.checked || searaGourmetCheckbox.checked;
            }
            if (isAnyCheckboxChecked()) {
                validation.form();

                if (validation.valid()) {
                    const formData = new FormData($forms[0]);
                    const $form = $forms;

                    $('#footer-newsletter input.new-newsletter-submit', $form).attr(
                        "disabled",
                        "disabled"
                    );

                    if (dataLayer) {
                        dataLayer.push({
                            event: $form.attr("data-tracking") + "-send",
                        });
                    }

                    ajaxified_form({
                        formData,
                        $form,
                        type: $('input[name="formtype"]', $form).val(),
                        ajaxAction: "ajax_send_newsletter_form",
                        elementErrorMessage: $(".form-error-message", $form),
                        elementSubmitButton: $(
                            '#footer-newsletter input.new-newsletter-submit',
                            $form
                        ),
                        successCallback: function () {
                            if ($form.hasClass("form--newsletter")) {
                                $("#footer-newsletter .newsletter-success").addClass("active");
                                $("#footer-newsletter form").addClass("hidden");
                                if ($("#bbb25").length) {
                                    $("bbb25").addClass("actived");
                                }
                            }
                        },
                    });
                }
            } else {
                let campoSelected = document.querySelector(
                    ".new-newsletter-opt .form-group"
                );
                campoSelected.style.background = "#ffcac9";
                campoSelected.style.borderColor = "#f03838";
                campoSelected.innerHTML = `<label id="error-brand" class="error" for="brand">*Escolha uma das opções.</label> ${campoSelected.innerHTML}`;
                let seara_Checkbox = document.querySelector('input[name="seara"]');
                let seara_GourmetCheckbox = document.querySelector(
                    'input[name="seara-gourmet"]'
                );
                seara_Checkbox.addEventListener("click", removeStyles);
                seara_GourmetCheckbox.addEventListener("click", removeStyles);
            }
        } else {
            validation.form();

            if (validation.valid()) {
                const formData = new FormData($forms[0]);
                const $form = $forms;
                let $page_url = window.location.href;
                formData.append("page_url", $page_url)

                $('#footer-newsletter input.new-newsletter-submit', $form).attr(
                    "disabled",
                    "disabled"
                );

                if (dataLayer) {
                    dataLayer.push({
                        event: $form.attr("data-tracking") + "-send",
                    });
                }

                // define para qual action vai ser enviado
                let actionFormName = $("#form-action-name").val() ? $("#form-action-name").val() : "ajax_send_newsletter_form";

                let destinationFormName = $("#form-destination-name").val() ? $("#form-destination-name").val() : "";
                formData.append("destinationFormName", destinationFormName);

                let formEventSlug = $("#form-event-slug").val() ? $("#form-event-slug").val() : "";
                formData.append("formEventSlug", formEventSlug);


                ajaxified_form({
                    formData,
                    $form,
                    type: $('input[name="formtype"]', $form).val(),
                    ajaxAction: actionFormName, //"ajax_send_newsletter_form",
                    elementErrorMessage: $(".form-error-message", $form),
                    elementSubmitButton: $(
                        '#footer-newsletter input.new-newsletter-submit',
                        $form
                    ),
                    successCallback: function (data) {
                        if ($form.hasClass("form--newsletter")) {
                            $("#footer-newsletter .newsletter-success").addClass("active");
                            $("#footer-newsletter form").addClass("hidden");
                            //Termina aqui
                            if (
                                document.body.classList.contains("seara-momento-gourmet") &&
                                document.getElementById("form-action-name").value ===
                                "cadastro_momentos_gourmet"
                            ) {
                                submitWrapper.querySelector(".button-loader-spinner").remove();
                                submitButton.value = submitButton.dataset.originalText;
                                submitButton.disabled = false;
                                document
                                    .querySelector("#footer-newsletter .newsletter-success")
                                    .classList.add("active"); // Exibe a mensagem de sucesso
                            }
                        }
                    },
                });
            } else {
                if ($(".button-loader-spinner")) {
                    if (
                        document.body.classList.contains("seara-momento-gourmet") &&
                        document.getElementById("form-action-name").value ===
                        "cadastro_momentos_gourmet"
                    ) {
                        submitWrapper.querySelector(".button-loader-spinner").remove();
                        submitButton.value = submitButton.dataset.originalText;
                        submitButton.disabled = false;
                    }
                }
            }
        }
    });

    //smoothscroll
    $('a[href^="#"]').on("click", function (e) {
        e.preventDefault();

        $("a").each(function () {
            $(this).removeClass("stick-active");
        });

        $(this).addClass("stick-active");

        if ($(this).closest(".gallery").length) {
            // go to href animated
            $("html, body").animate(
                {
                    scrollTop: $($(this).attr("href")).offset().top,
                },
                500,
                "linear"
            );
        }
    });

    // var myvid = jQuery('video.autoplay-onscroll')[0];
    // jQuery(window).scroll(function () {
    //   jQuery(myvid).isInViewport() ? myvid.play() : myvid.pause()
    // })

    function display_message(data, callback) {
        let $messages = [];
        let $status = "";
        let $data = data ? data : "";
        if ($data.responseText) {
            let $response_text = $data.responseText;
            $response_text = $response_text.replace(/}{/g, "},{");
            $response_text = JSON.parse("[" + $response_text + "]");
            $messages = $response_text.map((obj) => obj.message);
        } else {
            $messages.push(data.message);
            $status = $data.status;
        }
        let $total_messages = $messages.length;
        let $messages_displayed = 0;
        jQuery("#modal").fadeIn();
        jQuery("#modal #tag").text("Aguarde...");
        jQuery("#modal #text-content").html(`<span id="message"></span>`);
        $messages.forEach(($message, $index) => {
            setTimeout(() => {
                jQuery("#modal #message").slideUp();
                jQuery("#modal #text-content").html(
                    `<span id="message">${$message}</span>`
                );
                $messages_displayed++;
                if ($messages_displayed === $total_messages) {
                    if ($status === "" || $status === "success") {
                        jQuery("#modal #tag").text("Pronto!").addClass("success");
                        jQuery("#modal #modal-close").on("click", () => {
                            if (location.pathname === "/meus-favoritos/") {
                                location.reload();
                            } else {
                                callback();
                            }
                        });
                    } else if ($status === "error") {
                        jQuery("#modal #tag").text("Opa...").addClass("error");
                        jQuery("#modal #modal-close").on("click", () => callback());
                    } else {
                        jQuery("#modal #tag").text("Opa...").addClass("warning");
                        jQuery("#modal #modal-close").on("click", () => callback());
                    }
                }
            }, 2000 * $index);
        });
    }
    /*
     * Wishlist
     */
    const post = (data, callback) => {
        $.ajax({
            type: "POST",
            url: ajaxScript.ajaxurl,
            data: {
                action: "check_wishlist",
                url: data,
            },
            success: (response) => {
                response = JSON.parse(response);
                // console.log("response: ", response["wishlist"]);
                callback(response);
            },
            error: (error) => {
                console.log(
                    "Ocorreu um erro no envio dos dados. Por favor, tente de novo em instantes."
                );
            },
        });
    };
    jQuery(".product-thumb-header-favorite").each((index, product) => {
        jQuery(product).on("click", function (e) {
            e.preventDefault();
            let url = jQuery(this)
                .parents(".product-thumb--inner")
                .find("a")
                .attr("href");
            post(url, (response) => {
                if (response["action"] === "add" || response["action"] === "remove") {
                    jQuery(product).addClass("active");
                    display_message(
                        {
                            status: "success",
                            message: response["wishlist"],
                        },
                        () => { }
                    );
                } else {
                    jQuery(product).removeClass("active");
                    display_message(
                        {
                            status: "error",
                            message: response["wishlist"],
                        },
                        () => { }
                    );
                }
            });
        });
    });
});

// Limpa o console ao fim do carregamento
jQuery(window).on('load', function () {
    console.clear();
});
